<template>
    <div>
        <b-modal ref="modal-document-allocations" size="xl">
            <template v-slot:modal-header="{ close }">
                <div class="row" style="width: 100%">
                    <div class="col-md-10 offset-md-1 text-center">
                        <h3>{{ __('allocated') }}
                            <button-open-help-modal :inExtraDiv="false" v-bind:helpName="helpName" :color="'dark'"/>
                        </h3>
                    </div>
                    <div class="col-md-1">
                        <button class="close" type="button" @click="hideModalAllocations()">
                            <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                    </div>
                </div>
            </template>

            <template v-slot:default="{}">
                <table class="modal-table">
                    <thead class="modal-table-part">
                    <tr>
                        <th class="th-first"></th>
                        <th class="th-before th-last text-right" colspan="11">
                            {{ __('starting_balance') }}: <strong>{{ actualGross() }}</strong>
                        </th>
                    </tr>
                    </thead>

                    <tbody v-if="documentData" class="modal-table-part">
                    <document-allocations
                        v-for="allocation in documentData.document_allocations"
                        :key="allocation.id"
                        :allocation="allocation"
                        :controls="['history']">
                    </document-allocations>

                    <allocations-for-document
                        v-for="allocation in documentData.allocations_for_documents"
                        :key="allocation.id"
                        :allocation="allocation"
                        :controls="['history']">
                    </allocations-for-document>

                    <operation-allocations
                        v-for="allocation in documentData.operation_allocations"
                        :key="allocation.id"
                        :allocation="allocation"
                        :controls="['history']">
                    </operation-allocations>

                    <document-corrections
                        v-for="correction in documentData.corrections"
                        :key="correction.id"
                        :controls="['history']"
                        :correction="correction">
                    </document-corrections>

                    <tr v-show="documentData.corrected_document" class="document-allocations normal-wrap">
                        <td :colspan="11" class="left-border">
                            {{ __('settlement_date') }}: <strong>{{ documentData.corrected_document.date }}</strong>&nbsp;|
                            <span class="text-capitalize">{{ __('type') }}</span>
                            <strong>{{ documentData.corrected_document.type }}</strong>&nbsp;|
                            {{ __('No') }}: <strong>{{ documentData.corrected_document.number }}</strong>&nbsp;|
                            {{ __('contractor') }}: <strong>{{ documentData.corrected_document.contractor }}</strong>&nbsp;|
                            {{ __('gross_amount') }}: <strong>{{
                                documentData.corrected_document.gross_amount
                            }}</strong>&nbsp;|
                            {{ __('currency') }}: <strong>{{ documentData.corrected_document.currency }}</strong>&nbsp;|
                            {{ __('allocated') }}: <strong>{{ documentData.corrected_document.allocated }}</strong>&nbsp;|
                            {{ __('currency') }}: <strong> {{ documentData.corrected_document.currency }}</strong>
                        </td>
                    </tr>

                    </tbody>

                    <thead class="modal-table-part">
                    <tr>
                        <th class="th-first"></th>
                        <th class="th-before th-last text-right" colspan="11">
                            {{ __('document_balance') }}: <strong>{{ actualBalance }}</strong>
                        </th>
                    </tr>
                    </thead>
                </table>
            </template>
            <template v-slot:modal-footer="{}">
                <div class="row">
                    <div class="col-md-12">
                        <button class="btn btn-white" type="button" @click="hideModalAllocations">{{ __('close') }}
                        </button>
                    </div>
                </div>
            </template>
        </b-modal>


        <b-modal ref="modal-unallocated-documents" size="lg">
            <template v-slot:modal-header="{ close }">
                <div class="row" style="width: 100%">
                    <div class="col-md-10 offset-md-1 text-center">
                        <h3>
                            {{ __('unallocated_payments') }}
                            <button-open-help-modal :inExtraDiv="false" v-bind:helpName="helpName" :color="'dark'"/>
                        </h3>
                    </div>
                    <div class="col-md-1">
                        <button class="close" type="button" @click="close()">
                            <span aria-hidden="true">×</span><span class="sr-only">Close</span>
                        </button>
                    </div>
                </div>
            </template>

            <template v-slot:default="{}">
                <div class="row">
                    <div class="col-md-12">
                        <div class="table-responsive text-nowrap">
                            <table class="table table-striped">
                                <thead>
                                <tr>
                                    <th class="th-first"><input v-model="checkAllBtn" :checked="checkAllBtn"
                                                                type="checkbox"
                                                                @click="checkAll"></th>
                                    <th class="text-capitalize">{{ __('payment_date') }}</th>
                                    <th class="text-capitalize">{{ __('payment_source') }}</th>
                                    <th class="text-capitalize wrap-text-inside-td">{{ __('source_contractor') }}</th>
                                    <th class="text-capitalize">{{ __('description') }}</th>
                                    <th class="text-capitalize">{{ __('currency') }}</th>
                                    <th class="text-right text-capitalize">{{ __('amount') }}</th>
                                    <th class="text-right th-last text-capitalize">{{ __('for_allocation') }}</th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr v-for="payment in contractorPayments" class="row-odd row-one-line">
                                    <td class="td-padding">
                                        <input :checked="ids.includes(payment.id)" :value="payment.id"
                                               type="checkbox"
                                               @change="handleOperationSelect(payment)">
                                    </td>
                                    <td class="td-padding">{{ payment.date }}</td>
                                    <td class="td-padding" style="white-space: break-spaces">{{ payment.payment_source }}</td>
                                    <td class="td-padding wrap-text-inside-td">{{ payment.source_contractor }}</td>
                                    <td class="td-padding wrap-text-inside-td">{{ payment.description }}</td>
                                    <td class="td-padding">{{ payment.currency }}</td>
                                    <td class="td-padding text-right">{{ payment.operation_amount }}</td>
                                    <td class="td-padding text-right">{{ payment.target_amount }}</td>
                                </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </template>

            <template v-slot:modal-footer="{}">
                <div class="row">
                    <div class="col-md-12">
                        <button class="btn btn-white" type="button" @click="hideModal">{{ __('cancel') }}</button>
                        <button :disabled="modalConnectWithButtonDisabled" class="btn btn-primary" type="button"
                                @click="showConnectWithModal">{{ __('connect') }}
                        </button>
                    </div>
                </div>
            </template>

        </b-modal>

        <modal-connect-with
            ref="modalConnectWith"
            save_method="html"
            @close="handleModalConnectWithClose"
            @save="handleModalConnectWithSaved"
        />
        <help-modal/>
    </div>
</template>

<script>
import events from './../../services/Events.js';
import actions from "../../vuex/action_types";
import mutations from './../../vuex/mutation_types.js';
import hasTooltips from './../../mixins/hasTooltips.js';
import {Money} from '../../services/Money';
import DocumentAllocations from "./../../components/history-tables/document-details/DocumentAllocations";
import AllocationsForDocument from "./../../components/history-tables/document-details/AllocationsForDocument";
import OperationAllocations from "./../../components/history-tables/document-details/OperationAllocations";
import DocumentCorrections from "./../../components/history-tables/document-details/DocumentCorrections";
import ButtonOpenHelpModal from "./../../components/help/ButtonOpenHelpModal.vue";
import HelpModal from "./../../components/help/HelpModal.vue";
import {clearTooltips} from "../../modules/helpers";
import hasConnectWith from "../../mixins/hasConnectWith";

export default {
    name: "unallocatedPayments",
    mixins: [hasTooltips, hasConnectWith],
    components: {
        DocumentCorrections,
        OperationAllocations,
        AllocationsForDocument,
        DocumentAllocations,
        ButtonOpenHelpModal,
        HelpModal,
    },
    data: function () {
        return {
            money: new Money(),
            contractorPayments: [],
            payments: [],
            ids: [],
            document: undefined,
            documentData: null,
            checkAllBtn: false,
            emptyModalConnectWithData: {
                payments_settled: [],
                unallocated_payments: [],
                documents_settled: [],
                documents: [],
                unallocated_documents: [],
                options: [],
                errors: {},
                settlement_date: '',
                description: '',
            },
            actualBalance: 0,
        };
    },
    methods: {
        showModal(document) {
            this.document = document.reduce((obj, {name, value}) => {
                obj[name] = value;
                return obj;
            }, {});

            if (this.mode === 'create' || this.document.is_draft == 1) {
                toggleLoader()
                this.axios.get('/summaries/payments-and-unallocated-documents/contractor-payments/' + this.document.contractor_id)
                    .then(response => {
                        this.contractorPayments = response.data;
                        toggleLoader(false)
                    });
                this.$refs['modal-unallocated-documents'].show();
                setTimeout(() => {
                    $('.modal-dialog').draggable({
                        handle: ".modal-header"

                    });
                }, 1000)
                this.axios.get('/modals/connect-with/blank-options')
                    .then(response => {
                        this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_OPTIONS, response.data);
                    });
                return;
            }

            if (['edit', 'show'].includes(this.mode)) {
                this.axios.get('/records/documents/' + this.document.document_id + '/history')
                    .then(response => {
                        this.documentData = response.data;
                        this.setActualBalance();
                        this.$refs['modal-document-allocations'].show();
                        setTimeout(() => {
                            $('.modal-dialog').draggable({
                                handle: ".modal-header"

                            });
                        }, 1000)
                    });

            }

        },
        hideModal() {
            this.$refs['modal-unallocated-documents'].hide();
        },
        hideModalAllocations() {
            this.$refs['modal-document-allocations'].hide();
        },
        async showConnectWithModal() {
            this.payments.forEach(({id}) => this.$store.commit('selectOperation', id))
            let input_data = {
                operations: this.$store.getters.getSelectedOperations,
                documents: []
            };

            clearTooltips();
            this.hideModal();
            await this.setModalConnectWithData();
            await this.checkIfConnected(input_data);
        },
        async checkIfConnected(input_data) {
            await this.$store.dispatch(actions.CHECK_IF_CONNECTED, input_data);
            const {data} = await this.$store.dispatch(actions.CHECK_CAN_CONNECT, input_data);

            if(data.can_connect == 'true') {
                events.$emit('showConnectWithModal', []);
            } else {
                window.location = data.redirect_url;
            }
        },
        handleOperationSelect: function (operation) {
            event.target.checked ? this.selectOperation(operation) : this.removeOperation(operation);
            !event.target.checked ? this.checkAllBtn = false : '';
        },
        selectOperation: function (operation) {
            const index = this.getIndex(operation);
            if (index < 0) {
                this.payments.push(operation);
                this.ids.push(operation.id);
            }
        },
        removeOperation: function (operation) {
            const index = this.getIndex(operation);
            if (index >= 0) {
                this.payments.splice(index, 1);
                this.ids.splice(this.ids.indexOf(operation.id), 1);
            }
        },
        getIndex: function (operation) {
            return this.payments.findIndex(storedOperation => operation.id === storedOperation.id);
        },
        async setModalConnectWithData() {
            let modalData = {...this.emptyModalConnectWithData};
            this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DATA, modalData);

            if (this.payments.length > 0) {
                const serverInfo = this.$store.getters.getServerInfo;
                const paymentIds = this.payments.reduce((paymentIds, {id}) => [...paymentIds, id], [])

                let typeOfInterpretation = this.getInterpretationType([this.document], paymentIds)

                if(typeOfInterpretation !== ''){
                    const {data} = await this.$store.dispatch(actions.PRE_VALIDATE_SELECTED_FOR_DOCUMENT, {document: this.document, operations: paymentIds, typeOfInterpretation})

                    if (data.status.toLowerCase() === 'ok') {
                        this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DATA, data.result);
                        this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_OPTIONS, data.options);
                        this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DATE, serverInfo.date);
                        this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DESCRIPTION, '');
                        this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_CURRENCY_EXCHANGE, false);
                    }
                }

            } else {
                throw new Error('No payments selected, can`t set modal-connect-with data');
            }

        },
        clearBothModals: function () {
            // wait for animation to complete
            setTimeout(() => {
                this.$store.commit(mutations.SET_MODAL_CONNECT_WITH_DATA, this.emptyModalConnectWithData);
                this.payments = [];
                this.contractorPayments = [];
                this.document = {};
                this.ids = [];
            }, 400);
        },
        handleModalConnectWithSaved: function () {
            this.clearBothModals();
            const button = document.querySelector('.connect-with');
            const icon = button.querySelector('.connect-with-icon');

            button.setAttribute('data-connected', '1');
            icon.classList.remove('fa');
            icon.classList.remove('fa-plus');
            icon.classList.add('fas');
            icon.classList.add('fa-minus');
            icon.parentNode.dataset.originalTitle = this.__('delete_allocation');
        },
        handleModalConnectWithClose: function () {
            setTimeout(() => {
                this.$refs['modal-unallocated-documents'].show();
            }, 500);
        },
        checkAll: function () {
            const handleSelect = event.target.checked ? this.selectOperation : this.removeOperation;
            this.contractorPayments.forEach(payment => handleSelect(payment));
        },

        actualGross() {
            return this.money.localize(this.document.adjusted_gross);
        },

        setActualBalance() {
            const parse = (value) => parseFloat(value);
            const isCorrection = (document) => ['foreign_invoice_correction', 'own_invoice_correction'].includes(document.document_type);
            let grossValue = isCorrection(this.document) ? parse(this.document.document_gross_amount) : Math.abs(parse(this.document.document_gross_amount));
            let balanceDelta = isCorrection(this.document) ? parse(this.document.adjusted_gross) * (this.document.type_group === "foreign_documents" ? -1 : 1) : parse(this.document.balance_delta);

            this.actualBalance = this.money.localize(
                (this.document.type_group === "foreign_documents" ? -1 : 1) * (grossValue - balanceDelta),
            );
        },
    },
    computed: {
        modalConnectWithButtonDisabled: function () {
            let choice_is_valid = false;

            if (this.document && this.payments.length === 1) choice_is_valid = true;

            if (this.document && this.payments.length >= 2) {
                let test_func;
                if (this.document.type_group === 'foreign_documents') test_func = payment => parseFloat(payment.operation_amount.replace(',', '.')) < 0;
                if (this.document.type_group === 'own_documents') test_func = payment => parseFloat(payment.operation_amount.replace(',', '.')) > 0;
                choice_is_valid = test_func && this.payments.every(test_func);
            }

            return !(choice_is_valid);
        },
    },
    props: {
        mode: {
            type: String,
            required: true,
            validator: function (value) {
                return ['show', 'edit', 'create'].includes(value);
            },
        },
        'helpName': {
            type: String,
            default: null,
        },
    },
    mounted() {
        this.$events.on('showUnallocatedPaymentsModal', (document) => this.showModal(document));
    },
};
</script>

<style> /* not scoped  */
.modal-backdrop {
    opacity: 0.5;
}

.modal-wrapper {
    font-size: 11px;
}

.modal-table {
    width: 100%;
}

.modal-table-part > tr > td {
    padding: 8px 5px 8px 5px;
    font-size: 12px !important;
}

.modal-table-part > tr > th {
    padding: 8px 5px 8px 5px;
    font-size: 12px !important;
}

.modal-xl {
    max-width: 1500px !important;
}

tr.document-allocations > td.left-border {
    border-left: 0 !important;
}

tbody.modal-table-part > tr:nth-child(even) {
    background-color: #fafafa;
    border-top: 1px solid #e7eaec;
    border-bottom: 1px solid #e7eaec;
}
</style>-
